import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";
import { FiRefreshCw } from "react-icons/fi";

import { Button } from "../../../../../../../../components/Form";
import { Color } from "../../../../../../../../components/Form/Button";
import { Wrapper, WrapperLeftSide, Title } from "./styles";

export enum InventoryType {
  ACTUAL = "Actual",
  QUOTED = "Quoted",
}

interface HeaderProps {
  rightSide?: React.ReactChild;
  inventoryType: string;
  setInventoryType?: (value: string) => void;
}

export default function Header(props: HeaderProps) {
  const { rightSide, inventoryType = "", setInventoryType } = props;
  const { t: translate } = useTranslation();

  const isActualInventory = inventoryType === InventoryType.ACTUAL;

  const onSwitchLabel = useMemo(
    () =>
      isActualInventory
        ? translate("switchToQuotedInventory")
        : translate("switchToActualInventory"),
    [inventoryType]
  );

  const onSwitch = () => {
    if (!setInventoryType) return;
    if (isActualInventory) setInventoryType(InventoryType.QUOTED);
    else setInventoryType(InventoryType.ACTUAL);
  };

  return (
    <Wrapper>
      <WrapperLeftSide>
        <Title data-cy="title">
          {inventoryType} {translate("inventory")}
        </Title>

        {!!setInventoryType && (
          <Button customColor={Color.INFO} startIcon={<FiRefreshCw size={16} />} onClick={onSwitch}>
            {onSwitchLabel}
          </Button>
        )}
      </WrapperLeftSide>
      {rightSide}
    </Wrapper>
  );
}
